import { getFullArea } from '@/api/area'

const state = {
  fullAreaList: []
}
const mutations = {
  SET_FULL_AREA: (state, fullAreaList) => {
    state.fullAreaList = fullAreaList
  }
}

const actions = {
  // 获取全省市区列表（树）
  async getFullArea ({ state, commit }, param = {}) {
    if (state.fullAreaList.length) { return false }
    const { cityCode } = param
    const response = await getFullArea({ cityCode })
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_FULL_AREA', data)
      return data
    } else {
      commit('SET_FULL_AREA', [])
      return []
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
